import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {
  public update$: Subject<any> = new Subject<any>();
}
